import ApiService from "@/core/services/api.service";

const _ = require('lodash');
export const PATH_HOLIDAY = "greeting-card";
export const GET_MESSENGERS = "GET_MESSENGERS";
export const SENT_MESSENGER = "SENT_MESSENGER";
export const FIND_USERS = "greeting-card/filter-receiver";

const state = {};
const getters = {};
const actions = {
    // Get provinces
    [GET_MESSENGERS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(PATH_HOLIDAY, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [FIND_USERS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(FIND_USERS, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [SENT_MESSENGER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH_HOLIDAY, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
};
const mutations = {};
export default {
    state,
    actions,
    mutations,
    getters
};
